var map = {
	"./audio-placeholder": 574,
	"./audio-placeholder.png": 574,
	"./avatar-missing": 459,
	"./avatar-missing.png": 459,
	"./avatar-missing.svg": 980,
	"./header-missing": 491,
	"./header-missing.png": 491,
	"./soapbox-logo": 492,
	"./soapbox-logo-white": 493,
	"./soapbox-logo-white.svg": 493,
	"./soapbox-logo.svg": 492,
	"./video-placeholder": 575,
	"./video-placeholder.png": 575,
	"./void": 576,
	"./void.png": 576,
	"./web-push/web-push-icon_expand": 654,
	"./web-push/web-push-icon_expand.png": 654,
	"./web-push/web-push-icon_favourite": 655,
	"./web-push/web-push-icon_favourite.png": 655,
	"./web-push/web-push-icon_reblog": 656,
	"./web-push/web-push-icon_reblog.png": 656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 979;